import { useState } from "react";
import Icon from "../../components/shared/Icon";
import { SA_MENU } from "../../data/initialData";
import SADash from "./SADash";
import SACreate from "./SACreate";
import SAList from "./SAList";
import SASocieties from "./SASocieties";
import SASettings from "./SASettings";

export default function SuperAdminApp({ onLogout }) {
  const [pg, setPg]       = useState("sa-dash");
  const [editAdmin, setEditAdmin] = useState(null);

  const handleAdd    = () => { setPg("sa-list"); setEditAdmin(null); };
  const handleEdit   = (admin) => { setEditAdmin(admin); setPg("sa-create"); };
  const handleEditDone = () => { setEditAdmin(null); setPg("sa-list"); };

  const renderPage = () => {
    switch(pg) {
      case "sa-dash":     return <SADash setPage={setPg} />;
      case "sa-create":   return <SACreate onAdd={handleAdd} editData={editAdmin} onEditDone={handleEditDone} />;
      case "sa-list":     return <SAList onEdit={handleEdit} />;
      case "sa-societies":return <SASocieties />;
      case "sa-settings": return <SASettings />;
      default:            return <SADash setPage={setPg} />;
    }
  };

  return (
    <div style={{ fontFamily:"'Segoe UI',system-ui,sans-serif", minHeight:"100vh", background:"#f0f2f8" }}>
      {/* Sidebar */}
      <div style={{ width:220, minHeight:"100vh", background:"linear-gradient(180deg,#0d1b3e 0%,#1a2f6b 100%)", position:"fixed", left:0, top:0, bottom:0, zIndex:100, display:"flex", flexDirection:"column" }}>
        <div style={{ padding:"18px 16px", borderBottom:"1px solid rgba(255,255,255,0.08)", display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ width:38, height:38, borderRadius:10, background:"linear-gradient(135deg,#f59e0b,#ef4444)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}><Icon name="shield" size={20} color="#fff" /></div>
          <div>
            <div style={{ color:"#fff", fontWeight:800, fontSize:14 }}>Ap IT Services</div>
            <div style={{ color:"#f59e0b", fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"1px" }}>Super Admin</div>
          </div>
        </div>
        <nav style={{ flex:1, padding:"12px 8px" }}>
          {SA_MENU.map(item => (
            <button key={item.id} onClick={() => setPg(item.id)}
              style={{ width:"100%", display:"flex", alignItems:"center", gap:9, padding:"10px 12px", background: pg===item.id?"rgba(245,158,11,0.18)":"transparent", border:"none", borderRadius:8, cursor:"pointer", color: pg===item.id?"#f59e0b":"#b0bec5", fontSize:13, fontWeight: pg===item.id?600:400, marginBottom:2, textAlign:"left", transition:"all 0.15s" }}
              onMouseEnter={e=>{ if(pg!==item.id) e.currentTarget.style.background="rgba(255,255,255,0.06)"; }}
              onMouseLeave={e=>{ if(pg!==item.id) e.currentTarget.style.background="transparent"; }}>
              <Icon name={item.icon} size={15} color={pg===item.id?"#f59e0b":"#78909c"} />
              {item.label}
            </button>
          ))}
        </nav>
        <button onClick={onLogout} style={{ margin:"12px 8px", padding:"10px 12px", background:"rgba(239,68,68,0.15)", border:"none", borderRadius:8, cursor:"pointer", color:"#ef4444", fontSize:13, fontWeight:500, display:"flex", alignItems:"center", gap:8 }}>
          <Icon name="logout" size={15} color="#ef4444" /> Logout
        </button>
      </div>

      {/* Topbar */}
      <div style={{ position:"fixed", top:0, left:220, right:0, height:54, background:"#fff", borderBottom:"1px solid #e8eaf0", display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0 24px", zIndex:90, boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
        <div style={{ fontWeight:700, fontSize:15, color:"#1a2744" }}>Ap IT Services — Super Admin</div>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ width:30, height:30, borderRadius:"50%", background:"linear-gradient(135deg,#f59e0b,#ef4444)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, color:"#fff", fontWeight:700 }}>SA</div>
          <button onClick={onLogout} style={{ background:"#fce8e6", border:"none", borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:12, color:"#c62828", fontWeight:500, display:"flex", alignItems:"center", gap:5 }}>
            <Icon name="logout" size={13} color="#c62828" /> Logout
          </button>
        </div>
      </div>

      {/* Main */}
      <main style={{ marginLeft:220, marginTop:54, padding:24, minHeight:"calc(100vh - 54px)" }}>
        {renderPage()}
      </main>
    </div>
  );
}
